import {
   CurrentAccountPersonalCertificateMetadataQuery,
   PersonalCertificateMetadata,
} from '@dreryk/egabinet-personal-certificate-frontend-api';

import { useCqrsFind, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useCertificateQuery = (): UseCqrsQueryResult<PersonalCertificateMetadata | null> => {
   return useCqrsFind<PersonalCertificateMetadata>(() => new CurrentAccountPersonalCertificateMetadataQuery());
};
